<template>
  <div>
    <img-dialog-header
      :image-url="page.active_image ? page.active_image.url : ''"
    >
      <div class="prose content" v-html="page.template.introductie"/>
    </img-dialog-header>

    <wave-content>
      <div class="prose content" v-html="page.template.tekst"/>
    </wave-content>

    <faq-block v-if="!$apollo.loading" :elements="handleidingen" handleiding header-txt="Filmpjes handleiding"/>

    <mentor-quickview/>
  </div>
</template>

<script>
import ImgDialogHeader from '~/components/headers/ImgDialogHeader';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';
import MentorQuickview from '~/components/begeleiders/MentorQuickview';
import FaqBlock from '~/components/fullwidth-blocks/AccordionBlocks';
import handleidingen from '~/graphql/queries/handleidingen';
import page from '~/plugins/mixins/page';

export default {
  components: {MentorQuickview, WaveContent, ImgDialogHeader, FaqBlock},
  mixins: [page],
  apollo: {
    handleidingen: {
      query: handleidingen,
    },
  },
  data: () => ({
    handleidingen: [],
  }),
};
</script>
